import { render, staticRenderFns } from "./InventorySidebar.vue?vue&type=template&id=92263212&scoped=true&"
import script from "./InventorySidebar.vue?vue&type=script&lang=js&"
export * from "./InventorySidebar.vue?vue&type=script&lang=js&"
import style0 from "./InventorySidebar.vue?vue&type=style&index=0&id=92263212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92263212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92263212')) {
      api.createRecord('92263212', component.options)
    } else {
      api.reload('92263212', component.options)
    }
    module.hot.accept("./InventorySidebar.vue?vue&type=template&id=92263212&scoped=true&", function () {
      api.rerender('92263212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Inventory/InventorySidebar.vue"
export default component.exports